import React, {Component} from 'react';
import _ from 'lodash';
import {Col, Card, CardBody, CardHeader, Table} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import filterFactory, {
    selectFilter,
    textFilter,
} from 'react-bootstrap-table2-filter';
import {api_base_url} from "../../../settings";
import Deserialiser from 'deserialise-jsonapi'
import Loading from '../../dumb/loading'

import ExportCSVButton from '../../dumb/fancyTable/ExportCSVButton'
import ExportXLSXButton from '../../dumb/fancyTable/ExportXLSXButton'
import {paginationOptions} from '../../dumb/fancyTable/Pagination'
import ColumnHeader from "../../dumb/fancyTable/columnHeader";

const des = new Deserialiser();

class ModelCrisprKO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeColumns: 5,
            model: props.model
        };

        this.wideBoxThreshold = 5;

        this.loadCrisprKO = this.loadCrisprKO.bind(this)
        this.renderTable = this.renderTable.bind(this)
        this.onColumnToggleHandler = this.onColumnToggleHandler.bind(this);
    }


    onColumnToggleHandler(activeColumns) {
        this.setState({activeColumns});
    }


    loadCrisprKO() {
        const model_id = this.state.model.id;

        const url = `${api_base_url}/models/${model_id}/datasets/crispr_ko?merged=true&page[size]=0&include=gene&fields[gene]=symbol,cancer_driver&sort=fc_clean_qn&filter=[{"name":"gene","op":"has","val":{"name": "hgnc_status", "op": "eq", "val": "current"}},{"name": "bf_scaled", "op": "lt", "val": "0"}]`;

        fetch(url)
            .then(response => response.json())
            .then(resp_obj => {
                return des.deserialise(resp_obj)
            })
            .then(essentialities => {

                    this.setState({
                        essentialities: essentialities,
                        load_complete: 1
                    })
                }
            ).catch(function (ex) {
            console.log('parsing failed', ex);
        });
    }


    renderTable() {
    
        const booleanOptions = {
            true: 'Yes',
            false: 'No',
        };

        const columns = [
            {
                dataField: 'gene.symbol',
                text: "Symbol",
                sort: true,
                filter: textFilter({placeholder: ' '}),
                headerFormatter: (column, colIndex, {sortElement, filterElement}) =>
                        <ColumnHeader column={column} colIndex={colIndex} sortElement={sortElement} filterElement={filterElement} />,
                tooltipText: "Gene Symbol"
            }, {
                dataField: 'gene.cancer_driver',
                text: "Cancer driver gene",
                filter: selectFilter({placeholder: ' ', options: booleanOptions}),
                formatter: cell => booleanOptions[cell],
                headerFormatter: (column, colIndex, {sortElement, filterElement}) =>
                        <ColumnHeader column={column} colIndex={colIndex} sortElement={sortElement} filterElement={filterElement} />,
                tooltipText: "Mutation is in a known cancer driver gene",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '120px', whiteSpace: 'wrap'};
                }
            }, {
                dataField: 'fc_clean_qn',
                text: "Corrected log fold change",
                sort: true,
                filter: textFilter({placeholder: ' '}),
                headerFormatter: (column, colIndex, {sortElement, filterElement}) =>
                        <ColumnHeader column={column} colIndex={colIndex} sortElement={sortElement} filterElement={filterElement} />,
                tooltipText: "Corrected log fold change"
            }, {
                dataField: 'bf_scaled',
                text: "Loss of fitness score",
                sort: true,
                filter: textFilter({placeholder: ' '}),
                headerFormatter: (column, colIndex, {sortElement, filterElement}) =>
                        <ColumnHeader column={column} colIndex={colIndex} sortElement={sortElement} filterElement={filterElement} />,
                tooltipText: "Loss of fitness score"
            }
        ];

        return (

            <ToolkitProvider
                keyField="id"
                data={this.state.essentialities}
                columns={columns}
                exportCSV={{fileName: `CMP_${this.state.model.names[0]}_essentialities.csv`}}
            >
                {
                    props => (
                        <div>
                            <div className="d-flex justify-content-left">
                                <b>Note:&nbsp;</b>All genes with a loss of fitness score &lt; 0.
                            </div>
                            <div className="d-flex justify-content-end">
                                <ExportCSVButton {...props.csvProps} />
                                <ExportXLSXButton data={this.state.essentialities} filename={`CMP_${this.state.model.names[0]}_essentialities`} />
                            </div>
                            <BootstrapTable
                                {...props.baseProps}
                                bootstrap4
                                hover
                                keyField='id'
                                bordered={false}
                                pagination={this.state.essentialities.length > 5 ? paginationFactory(paginationOptions(5, this.state.essentialities.length)) : null}
                                filter={filterFactory()}
                                tableHeaderClass="border-top-none"
                            />
                        </div>
                    )
                }
            </ToolkitProvider>


        )
    }

    componentDidMount() {
        this.loadCrisprKO()
    }

    componentDidUpdate() {
        if (this.state.model.id !== this.props.model.id) {
            this.setState({model: this.props.model, load_complete: false}, this.loadCrisprKO)
        }
    }

    render() {
        if (!this.state.model.crispr_ko_available) return null;

        let content = null;


        if (!this.state.load_complete) {
            content = (
                <div className="py-5"><Loading subtitle="Loading Crispr Dependencies" color="crispr" /></div>);
        } else {
            content = this.renderTable()
        }
        return (
            <Col className="my-3" lg={(this.state.activeColumns > this.wideBoxThreshold) ? 12 : 6}
                 xl={(this.state.activeColumns > this.wideBoxThreshold) ? 12 : 6}>
                <Card className="flex-fill genes">
                    <CardHeader>CRISPR Dependencies</CardHeader>
                    <CardBody>
                        {content}
                    </CardBody>
                </Card>
            </Col>
        );
    }
}

export default ModelCrisprKO;
